import { useEffect, useState } from 'react';
import { getModuleActions } from '../services/detailedViewApi';

// One fetch per module per page load — every row of a list shares the result.
const actionConfigCache = new Map();

export function useModuleActions(module) {
  const [config, setConfig] = useState({ actions: [], actionRules: [] });

  useEffect(() => {
    if (!module) return undefined;
    let cancelled = false;
    if (!actionConfigCache.has(module)) {
      actionConfigCache.set(
        module,
        getModuleActions(module).catch(() => {
          actionConfigCache.delete(module);
          return { actions: [], actionRules: [] };
        }),
      );
    }
    actionConfigCache.get(module).then((data) => {
      if (!cancelled) setConfig(data);
    });
    return () => { cancelled = true; };
  }, [module]);

  return config;
}
